import styles from './DashboardSales.module.css'

const Bone = ({ width = '100%', height = 12 }) => <span className={styles.skeletonBone} style={{ width, height }} />
const Metric = () => <div className={styles.metric}><Bone width="65%" /><Bone width={76} height={34} /><Bone width="82%" height={10} /></div>
const Heading = () => <div className={styles.sectionHeading}><Bone width={180} height={16} /><Bone width={240} height={10} /></div>
const PanelHeading = () => <div className={styles.panelHeader}><Bone width={160} height={16} /><Bone width={80} height={10} /></div>
const Lines = () => <div className={styles.skeletonLines}><Bone /><Bone width="88%" /><Bone width="64%" /></div>

const DashboardSalesSkeleton = () => <>
    <span className={styles.loadingAnnouncement} role="status">Caricamento della dashboard Sales…</span>
    <div className={styles.skeletonLayout} aria-hidden="true">
        <Heading />
        <div className={styles.metrics}>{[0, 1, 2, 3].map(key => <Metric key={key} />)}</div>
        <div className={styles.columns}>
            <div className={styles.panel}>
                <PanelHeading /><Lines />
                <div className={styles.funnel}>{[72, 100, 48, 32].map(width => <div className={styles.stage} key={width}>
                    <div className={styles.stageTitle}><Bone width={90} /><Bone width={24} /></div>
                    <Bone width={`${width}%`} height={9} /><Bone width="62%" height={10} />
                </div>)}</div>
            </div>
            <div className={styles.panel}>
                <PanelHeading />
                <div className={styles.tabs}>{[90, 100, 85, 95].map(width => <Bone key={width} width={width} height={30} />)}</div>
                <div className={styles.agenda}>{[0, 1, 2, 3, 4].map(key => <div className={styles.task} key={key}>
                    <span className={styles.skeletonTaskName}><Bone width={`${65 + key * 5}%`} /><Bone width="90%" height={10} /></span>
                    <span className={styles.skeletonTaskDate}><Bone width={75} height={10} /><Bone width={90} height={10} /></span>
                </div>)}</div>
                <div className={styles.skeletonPagination}><Bone width={115} height={10} /><Bone width={150} height={32} /></div>
                <div className={styles.footnote}><Bone width="85%" height={10} /></div>
            </div>
        </div>
        <Heading />
        <div className={styles.metrics}>{[0, 1, 2, 3].map(key => <Metric key={key} />)}</div>
        <div className={styles.columns}>
            <div className={styles.panel}><PanelHeading /><div className={styles.dualMetrics}><Metric /><Metric /></div><Lines /></div>
            <div className={styles.panel}><PanelHeading /><div className={styles.outcomes}>{[0, 1, 2, 3].map(key => <div key={key}><Bone width="80%" /><Bone width={40} height={26} /><Bone width="70%" height={10} /></div>)}</div><Lines /><div className={styles.payment}><Bone width="55%" /><Bone width={65} /></div><Lines /></div>
        </div>
        <div className={styles.panel}><PanelHeading /><div className={styles.reasons}>{[0, 1].map(key => <div key={key}><Bone width="65%" /><Bone width={20} /></div>)}</div></div>
        <div className={styles.panel}>
            <PanelHeading /><Lines />
            <div className={styles.skeletonTable}>{[0, 1, 2, 3, 4].map(row => <div className={styles.skeletonTableRow} key={row}>
                <Bone width={`${row % 2 ? 70 : 85}%`} height={row === 0 ? 10 : 12} />{[0, 1, 2, 3, 4, 5].map(col => <Bone key={col} width={row === 0 ? 48 : 28} height={row === 0 ? 10 : 12} />)}
            </div>)}</div>
        </div>
    </div>
</>

export default DashboardSalesSkeleton
